<script>
import { h } from "vue";
export default {
    name: "MdError",
    render(ctx) {
        const mdData = ctx.mdData || {};
        const name = mdData.name || '';
        const  theme  = mdData.theme || ''
        return h(
            'div',
            {
                class: `md-error ${process.env.NODE_ENV}`
            },
            [
                h('span', {}, ctx.$t('common:cmsPreview.loadFail', { name: name, theme: theme }))
            ]
        );
    }
}
</script>